import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className='border-b border-border bg-white'>
      <div className='mx-auto flex h-16 max-w-[960px] items-center justify-between px-6'>
        {/* Left: Logo + Site name */}
        <Link to='/' className='flex items-center gap-2.5'>
          <img src='/favicon.svg' alt='TONOME' className='h-8 w-8' />
          <span className='text-lg font-bold text-text'>TONOME Core</span>
        </Link>

        {/* Right: Core app link button */}
        <a
          href='https://core.tonome.jp'
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex items-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-secondary'
        >
          TONOME Coreへ
          <ArrowRight size={16} />
        </a>
      </div>

      {/* Green accent bar */}
      <div className='h-1 bg-primary' />
    </header>
  );
}
